<template>
  <div>
    <Ingress v-if="ingress" :content="ingress" :isLead="true" />
    <Byline v-if="!hasIntro" />
    <main ref:root>
      <Part :key=" idx" v-for="(part, idx) in parts" :idx="idx" :part="part" />
      <GetHelp />
      <ReadMore />
      <CommonFooter />
    </main>
  </div>
</template>

<style lang="postcss" scoped>
  main {
    position: relative;
    background: #fff;
    z-index: 1;
  }

  :global(.text-body) :global(a[href]) {
    color: #14a081;

    &:hover {
      border-bottom: 1px solid #14a081;
    }
  }
</style>

<script>
// import Esi from '../Utilities/Esi.vue'
import Part from './Part.vue'
import Byline from './Byline.vue'
import Ingress from './Ingress.vue'
import GetHelp from '../Widgets/GetHelp.vue'
import ReadMore from '../Widgets/ReadMore.vue'
import CommonFooter from '../Footer/index.vue'
// import JournalSeries from '../Sections/JournalSeries/index.vue'

export default {
  components: {
    Part,
    GetHelp,
    ReadMore,
    CommonFooter,
    Byline,
    Ingress
  },
  data() {
    const { doc } = this.$root.$data.props

    return {
      ingress: doc.ingress ? { item: { value: doc.ingress } } : null,
      hasIntro: Boolean(doc.intro),
      parts: Object.keys(doc)
        .filter(key => key.startsWith('part'))
        .reduce((arr, key) => {
          arr.push([key, doc[key]])
          return arr
        }, [])
    }
  }
}
</script>
